// @ vendor
import React from 'react';
import { Redirect } from 'react-router-dom';

// @ components
import { Info } from './components/info/info.component';
import { Rejected } from './components/rejected/rejected.component';
import { Terms } from './components/terms/terms.component';
import { LeaveModal } from './components/leaveModal/leaveModal';
import { VideocallInfo } from './components/videocallInfo/videocallInfo.component';
import { LoadingSection } from 'commonsComponents/loadingSection';
import { MigrationResult } from './components/migrationResult/migrationResult.component';
import { IdentificationCompletionHandler } from './components/identificationCompletionHandler/IdentificationCompletionHandler';

// @ constants
import {
  IDENTIFICATION_QUERY_RESULT,
  LOADER_WIDTH,
  MIGRATION_STATE,
} from './migrationUsersBranchView.constants';

// @helpers
import { useMigration } from './hooks/useMigration';
import { useQuery } from './hooks/useQuery';

const contentMigrationState = {
  [MIGRATION_STATE.INITIAL]: Info,
  [MIGRATION_STATE.REJECTED]: Rejected,
  [MIGRATION_STATE.TERMS_AND_CONDITIONS]: Terms,
  [MIGRATION_STATE.VIDEOCALL_INFO]: VideocallInfo,
  [MIGRATION_STATE.MIGRATION_KO]: MigrationResult,
  [MIGRATION_STATE.MIGRATION_SUCCESS]: MigrationResult,
};

export const MigrationUsersBranchView = () => {
  const {
    states: { isFetching, migrationState, modalType, showLeaveModal },
    actions: {
      getIsMigrationRouteAllowed,
      handleCancel,
      handleChangeMigrationState,
      handleCloseModal,
      handleContinue,
      handleExitHeader,
    },
  } = useMigration();

  const query = useQuery();
  window.utag_last_type = 'genérica';

  if (isFetching) {
    return (
      <div className="app__spinner">
        <LoadingSection type="round" width={LOADER_WIDTH} />
      </div>
    );
  }

  if (getIsMigrationRouteAllowed()) {
    if (
      [IDENTIFICATION_QUERY_RESULT.SUCCESS, IDENTIFICATION_QUERY_RESULT.KO].includes(
        query.get('identificationResult')
      ) &&
      ![MIGRATION_STATE.MIGRATION_KO, MIGRATION_STATE.MIGRATION_SUCCESS].includes(migrationState)
    ) {
      return (
        <IdentificationCompletionHandler
          result={query.get('identificationResult')}
          handleChangeMigrationState={handleChangeMigrationState}
        />
      );
    }

    const Component = contentMigrationState[migrationState] ?? <></>;
    return (
      <div>
        <Component
          handleChangeMigrationState={handleChangeMigrationState}
          handleExitLeaveModal={handleExitHeader}
          migrationState={migrationState}
        />
        <LeaveModal
          modalType={modalType}
          showModal={showLeaveModal}
          handleCancel={handleCancel}
          handleOnClose={handleCloseModal}
          handleContinue={handleContinue}
        />
      </div>
    );
  }
  return <Redirect to="/myprofile/global" />;
};

MigrationUsersBranchView.propTypes = {};
